import { ELoanStatus } from '../pages/LoanLists/consts/LoanStatus.enum';

export function getLoanStatusColor(status?: ELoanStatus): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  switch (status) {
    case ELoanStatus.NEW:
      return 'secondary';
    case ELoanStatus.COLLECTION:
      return 'error';
    case ELoanStatus.CURRENT:
      return 'success';
    case ELoanStatus.PAID_OFF:
      return 'info';
    case ELoanStatus.DELINQUET:
      return 'warning';
    case ELoanStatus.CANCELED:
      return 'primary';
    default:
      return 'default';
  }
}
